import { __rest } from "tslib";
import * as React from 'react';
const ChevronRightXLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 60 60", fill: "currentColor", width: size || "60", height: size || "60" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M18.7071068,6 L42.038,29.331 L42.0427589,29.3278702 L42.7498657,30.034977 L42.745,30.038 L42.7487373,30.0416306 L42.0416306,30.7487373 L42.038,30.745 L18.7082352,54.0766075 L18.0011284,53.3695007 L41.331,30.038 L18,6.70710678 L18.7071068,6 Z" })));
};
ChevronRightXLarge.displayName = 'ChevronRightXLarge';
export default ChevronRightXLarge;
//# sourceMappingURL=ChevronRightXLarge.js.map